import React from 'react';

const About = () => {
  return (
    <div style={styles.container}>
      <div style={styles.section}>
        <h1 style={styles.title}>About Us</h1>
        <p style={styles.description}>
          We are passionate about pinball and dedicated to bringing you the best pinball experience.
        </p>
        <p style={styles.description}>
          Capital Pinball Parlor is Sacramento's premier destination for pinball enthusiasts of all skill levels. 
          Whether you're a seasoned player or just discovering the joy of pinball, we provide a welcoming 
          environment with an amazing collection of machines.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh',
    padding: '20px',
    paddingTop: '10px',
  },
  section: {
    background: 'var(--card-bg)',
    color: 'var(--text-primary)',
    padding: 'clamp(24px, 5vw, 44px) clamp(18px, 4.5vw, 40px)',
    textAlign: 'center',
    maxWidth: '640px',
    width: '100%',
    borderRadius: '14px',
    border: '1px solid var(--card-border)',
    boxShadow: 'var(--card-shadow)',
  },
  title: {
    fontFamily: 'var(--font-heading)',
    fontSize: 'clamp(1.45rem, 5.2vw, 1.9rem)',
    marginBottom: '20px',
    color: 'var(--accent-gold)',
    textShadow: 'var(--accent-gold-glow)',
    lineHeight: 1.2,
  },
  description: {
    fontFamily: "'Rajdhani', sans-serif",
    fontSize: '17px',
    fontWeight: 500,
    marginBottom: '20px',
    lineHeight: '1.7',
    color: 'var(--text-secondary)',
    textAlign: 'left',
  },
};

export default About;
